// extracted by mini-css-extract-plugin
module.exports = {"mapStyles":"DepartmentMap_mapStyles__1h_er","infoWindow":"DepartmentMap_infoWindow__3Olbo"};